import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
import FormsInputPassword from "../../../forms/inputs/password/forms_inputs_password";

class SysadminFormsExcludedClinicAdd extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }
    renderSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Excluded Clinic Created Successfully!</Message.Header>
                    <p>
                        <Link to="/systemadmin/excludedclinic/list">
                            Click here to view the excluded clinic now!
                        </Link>
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        return (
            <Formik
                initialValues={{ 
                    code: ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={(values, actions) => {
                    console.log(values, actions);
                    this.setState({error: false, errorMessage: null, success: false});
                    this.props.submitSystemAdminCreateExcludedClinic(
                        {accessToken: this.props.user.accessToken, data: values},
                        (result, error) => {
                            if (result) {
                                actions.setSubmitting(false);
                                this.setState({error: false, errorMessage: null, success: true});
                            }
                            if (error) {
                                actions.setSubmitting(false);
                                this.setState({error: true, errorMessage: error.errorMessage});
                            }
                        }
                    )
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form style={{padding: 20}}>
                        <Grid container columns={2}>
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Excluded Clinic Basic Information
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="code" 
                                    label="Excluded Clinic Code" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Button 
                                    loading={isSubmitting}
                                    type="submit" 
                                    primary 
                                    disabled={isSubmitting}
                                    fluid
                                    size="big"
                                >
                                    Create New Excluded Clinic Record
                                </Button>
                            </Grid.Column>
                            <Grid.Column width={16}>
                                {this.renderSubmissionResult()}
                            </Grid.Column>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default SysadminFormsExcludedClinicAdd;